var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/spinner/spinner.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Stack from '../stack/stack';
import Text from '../text/text';
import './spinner.css';

/** Spinning loading placeholder. */
const Spinner = _ref => {
  let {
    size = 30,
    withText = true
  } = _ref;
  return /*#__PURE__*/React.createElement(Stack, {
    space: 2,
    justifyContent: "center",
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "spinner",
    style: {
      width: size,
      height: size
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 5
    }
  }, Array.from(Array(12).keys()).map(i => /*#__PURE__*/React.createElement("div", {
    key: i,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 9
    }
  }, "\xA0"))), withText && /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    tracking: "wide",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "loading_indicator.label",
    defaultMessage: "Loading\u2026",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 9
    }
  })));
};

export default Spinner;